import React, { useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section";
import CloseIcon from '@mui/icons-material/Close';
import ProductSingle from "../components/product";
import { useHistory } from "react-router-dom";
import listProduct from '../components/product.json'
const Product = () =>{
    const [count,setCount] = useState(0)
    
    return(
        <div id="product_cart" whihOne="cart">
                <div className="row col-12">
                    <div className="col noMP" id="img_cart_product_side">
                        <img src={"https://cdn.shopify.com/s/files/1/0213/5102/products/gallery7_023ad0c8-9d9c-47a7-8459-4e322c4eaff3.jpg?v=1571439757"} id="cart_img_product" alt=""/>
                    </div>
                    <div className="col-sm-2 mag-A" id="margin_bo">
                        <p id="cart_title_product">Farm Rio Melila Floral Flared Pants</p>
                    </div>
                    <div className="col-sm mag-A">
                    <select name="size" id="select_cart">
                        <option value="volvo" selected hidden>Size : M</option>
                        <option value="volvo">Size : M</option>
                    </select>
                    </div>
                    <div className="col mag-A">
                    <select name="color" id="select_cart">
                        <option value="volvo" selected hidden>Color: Gray</option>
                        <option value="volvo">Color: Gray</option>
                    </select>
                    </div>
                    <div className="col-2 mag-A">
                        <div id="count_product">
                            <ul>
                                <li id="one"
                                onClick={(()=>{
                                    if(count > 0){
                                        setCount(count-1)
                                    }
                                 
                                })}
                                >
                                    -
                                </li>
                                <li id="two">
                                    {count}
                                </li>
                                <li id="three"
                                 onClick={(()=>{
                                    setCount(count+1)
                                })}>
                                    +
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm mag-A">
                        <p id="cart_price_product">$523</p>
                    </div>
                    <div className="col-sm-1 mag-A">
                        <CloseIcon />
                    </div>
                </div>
        </div>
    )
}
const CartPage = () =>{
    const history = useHistory()
    return (
        <div>
            <Header />
               <HeaderSection name="Shopping Cart" />
               <section id="section_shop">
                    <div className="row col-12">
                        <div className="col-lg-8" style={{marginBottom:"22px"}}>
                            {
                                [1].map((v,k)=>{
                                    return(
                                        <Product></Product>
                                    )
                                })
                            }
                            <div className="row col-12 noMP">
                                <div className="col-sm-6 noMP">
                                    <ul id="left_side_footer">
                                        <li>
                                            <input type="code" id="cart_input_code" placeholder="Enter your coupon code" />
                                        </li>
                                        <li>
                                            <button id="cartApply">Apply Coupon</button>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-sm-6 noMP" >
                                    
                                    <button id="cart_Coutinue_Shopping"
                                    onClick={(()=>
                                        history.push('/shop')
                                    )} 
                                    >Coutinue Shopping</button>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div id="right_side_cart">
                                <p id="right_side_cart_title">Cart Total</p>
                                <hr id="line_cart" />
                                <div className="row col-12">
                                    <div className="col">
                                        <p id="right_side_cart_left_p">Subtotal</p>
                                    </div>
                                    <div className="col">
                                        <p id="right_side_cart_right_p">$300</p>
                                    </div>
                                </div>
                                <hr id="line_cart" />
                                <div className="row col-12">
                                    <div className="col-4">
                                        <p id="right_side_cart_left_p">Shipping</p>
                                    </div>
                                    <div className="col">
                                        <input id="right_side_cart_left_input" placeholder="Country" />
                                        <input id="right_side_cart_left_input" placeholder="City" />
                                        <input id="right_side_cart_left_input" placeholder="Postcode/zip" />
                                        <button id="right_side_cart_left_button">Update Total</button>
                                    </div>
                                </div>
                                <hr id="line_cart" />
                                <div className="row col-12">
                                    <div className="col">
                                        <p id="right_side_cart_left_p">Subtotal</p>
                                    </div>
                                    <div className="col">
                                        <p id="right_side_cart_right_p"><b style={{color:"black"}}>$300</b></p>
                                    </div>
                                </div>
                                <hr id="line_cart" />
                                <button id="end_cart_button">Shop now</button>
                            </div>
                        </div>
                    </div>
                    <hr style={{marginTop:"40px"}} />
                    <p id="similar_products">Similar Products</p>
                    <div id="grid_4_cart">
                        {
                            listProduct.map((v,k)=>{
                                return <ProductSingle  key={k} data={v}/>
                            })
                        }
                    </div>       
               </section>

            <Footer />
        </div>
    )
}
export default CartPage;
